import PageTypeB from "../components/pageTypeB/PageTypeB";
import { pagesDataB } from "../data/pagesData";

const Page15 = () => {
  return (
    <PageTypeB
      title={pagesDataB[4].title}
      paragraph1={pagesDataB[4].paragraph1}
      paragraph2={pagesDataB[4].paragraph2}
      paragraph3={pagesDataB[4].paragraph3}
    />
  );
};

export default Page15;
